export const SmallScreenAlert = () =>
{
    return (
    <div class = "alert alert__fullscreen">
        <h1>Ecranul tău este prea mic!</h1>
    </div>);
}